enum DefaultActions {
  SET = 'set',
  UPDATE = 'update',
  DELETE = 'delete',
}

export default DefaultActions;
